/**
 * Radix Dialog + react-remove-scroll can leave `pointer-events: none` or `overflow: hidden`
 * on <body>/<html> after a fast refresh or HMR while a dialog was open. That makes the
 * whole page "dead" (no pointer cursor, clicks swallowed) even though no dialog is visible.
 */
export function releaseStrandedDialogScrollLock(): void {
  if (typeof document === "undefined") return;
  const body = document.body;
  const html = document.documentElement;
  body.style.removeProperty("pointer-events");
  html.style.removeProperty("pointer-events");
  if (body.style.overflow === "hidden") {
    body.style.removeProperty("overflow");
  }
  if (html.style.overflow === "hidden") {
    html.style.removeProperty("overflow");
  }
  // react-remove-scroll adds padding-right to offset the missing scrollbar
  if (body.style.paddingRight) {
    body.style.removeProperty("padding-right");
  }
}
